import { createContext } from 'react';

const throwContextError = () => {
    throw new Error('Must be used inside <LogtoProvider> context.');
};
const LogtoContext = createContext({
    logtoClient: undefined,
    isAuthenticated: false,
    loadingCount: 0,
    error: undefined,
    setIsAuthenticated: throwContextError,
    setLoadingCount: throwContextError,
    setError: throwContextError,
});

export { LogtoContext, throwContextError };
